import solicitacaoProcessoModel from '@/components/abertura/solicitacaoProcesso.json';

export default {
  solicitacaoProcesso: { ...solicitacaoProcessoModel },
  rascunhos: {},
  solicitacoesProcesso: [],
  statusSolicitacaoProcesso: [],
  tiposProcesso: [],
  tiposDocumento: [],
  abrirModal: false,
  abrirModalVisualizacao: false,
  abrirModalOrdemCompra: false,
  isVisualizar: false,
  isAlterar: false,
  emAlteracao: false,
  exportadores: [],
  colunasItens: [
    {
      text: 'Itens',
      value: 'id',
    },
    {
      text: 'NCM',
      value: 'ncm',
    },
    {
      text: 'unidadeMedida',
      value: 'unidadeMedida',
    },
    {
      text: 'Quantidade',
      value: 'quantidade',
    },
    {
      text: 'descricao',
      value: 'descricao',
    },
    {
      text: 'valorUnitario',
      value: 'valorUnitario',
    },
    {
      text: 'total',
      value: 'total',
    },
    {
      text: 'Moeda',
      value: 'moeda',
    },
  ],
  colunasItensCotacao: [
    { text: 'NCM', value: 'ncm' },
    { text: 'unidadeMedida', value: 'unidadeMedida' },
    { text: 'Quantidade', value: 'quantidade' },
    { text: 'produto', value: 'nomeProduto' },
    { text: 'valorUnitario', value: 'valorUnitario' },
    { text: 'total', value: 'total' },
    { text: 'Moeda', value: 'moeda' },
  ],
  colunasItensProcesso: [
    { text: 'codigoCliente', value: 'codigoCliente' },
    { text: 'codigoTrust', value: 'codigoTrust' },
    { text: 'NCM', value: 'ncm' },
    { text: 'unidadeMedida', value: 'unidadeMedida' },
    { text: 'Quantidade', value: 'quantidade' },
    { text: 'produto', value: 'nomeProduto' },
    { text: 'descricao', value: 'descricao' },
    { text: 'valorUnitario', value: 'valorUnitario' },
    { text: 'total', value: 'total' },
    { text: 'Moeda', value: 'moeda' },
  ],
  colunasItensProcessoPDF: [
    { text: 'NCM', value: 'ncm' },
    { text: 'unidadeMedida', value: 'unidadeMedida' },
    { text: 'Quantidade', value: 'quantidade' },
    { text: 'produto', value: 'nomeProduto' },
    { text: 'descricao', value: 'descricao' },
    { text: 'valorUnitario', value: 'valorUnitario' },
    { text: 'total', value: 'total' },
    { text: 'Moeda', value: 'moeda' },
  ],
  filtros: {
    perPage: 20,
    page: 1,
    termo: '',
    referenciaCliente: '',
    referenciaTrust: '',
    status: '',
    usuario: '',
    tipoImportacao: '',
    finalidade: '',
    empresaImportador: '',
    dataSolicitacao: '',
    dataSolicitacaoCondicao: '',
    updatedAt: '',
    updatedAtCondicao: '',
    order: 'dataSolicitacao',
    direcao: 'DESC',
  },
  campos: {
    referenciaCliente: 'referenciaCliente',
    referenciaTrust: 'referenciaTrust',
    status: 'status',
    usuario: 'usuario',
    tipoImportacao: 'tipoImportacao',
    finalidade: 'finalidade',
    empresaImportador: 'empresaImportador',
    dataSolicitacao: 'dataSolicitacao',
    updatedAt: 'updatedAt',
  },
  colDefault: 'dataSolicitacao',
  directionDefault: 'DESC',
  modeloOrdemCompra: {
    modal: '',
    referenciaCliente: '',
    importador: {
      nome: '',
      doc: '',
      endereco: '',
    },
    exportador: {
      nome: '',
      endereco: '',
    },
    condicaoTransporte: {
      paisOrigem: '',
      incoterms: '',
      portoOrigem: '',
      portoDestino: '',
      termosPagamento: '',
      etd: '',
    },
    itens: [],
    observacao: '',
    ativo: true,
  },
  downloadOrdem: false,
  downloadProcesso: false,
};
